<template>
  <div class="veda-article">
    <div class="web-box wrap">
      <div v-if="loading" class="loading">
        <a-spin />
      </div>
      <div @click="back" class="backBtn">
        <span class="icon">&#xe63a;</span> 返回
      </div>
      <div style="height:40px"></div>
      <div class="card">
        <h2>{{articleData.title}}</h2>
        <p class="author">{{articleData.author}} | {{articleData.date}}</p>
        <div class="main" v-html="articleData.content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      articleData: {},
      loading: true
    };
  },
  created() {
    this.getArticle();
  },
  methods: {
    async getArticle() {
      const res = await axios.get("/allcustomer/api/article_detail", {
        params: {
          id: this.$route.query.id
        }
      });
      const { data } = res;
      this.loading = false;
      if (data && data.code === 200) {
        this.articleData = data.data;
      } else {
        this.$message.error(data.msg);
      }
    },
    back() {
      this.$router.back();
    }
  }
};
</script>
<style lang="scss" scoped>
.wrap {
  margin-top: 100px;
  min-height: 400px;

  position: relative;
  h2 {
    text-align: center;
    font-weight: 600;
  }
  .author {
    text-align: center;
  }
  .main {
    margin-top: 30px;
    font-size: 16px;
  }
  .card {
    width: 100%;
    padding: 40px 20px;
    background-color: #fff;
    border-radius: 6px;
  }
  .backBtn {
    cursor: pointer;
    position: absolute;
    left: 20px;
    top: 0;
    line-height: 30px;
    font-size: 16px;
    &:hover {
      color: #0f8cf0;
    }
    vertical-align: middle;
    .icon {
      display: inline-block;
      font-family: "iconfont";
      transform: rotate(180deg);
    }
  }
}
</style>